import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import BreadcrumbNav from '@/components/base/BreadcrumbNav';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory, getCategoryName, articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'shengli-yuanli');

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
    }
  }, [slug]);

  const filteredArticles = activeCategory === 'all'
    ? articles
    : getArticlesByCategory(activeCategory);

  const currentCategoryName = activeCategory === 'all' ? '全部文章' : getCategoryName(activeCategory);

  const schemaItemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: filteredArticles.map((article, idx) => ({
      '@type': 'ListItem' as const,
      position: idx + 1,
      item: {
        '@type': 'Article' as const,
        name: article.title,
        url: `https://yourdomain.com/article/${article.slug}`,
        description: article.summary,
        author: { '@type': 'Person', name: article.author },
        datePublished: article.date,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaItemList) }}
      />
      <div className="pt-24 pb-16 md:pb-20 min-h-screen">
        <BreadcrumbNav
          items={[
            { label: '首页', href: '/' },
            { label: '分类浏览', href: '/category/shengli-yuanli' },
            { label: currentCategoryName },
          ]}
        />

        <div className="w-full px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h1 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900">
                分类浏览
              </h1>
              <p className="mt-2 text-sm text-foreground-500">选择你感兴趣的主题，浏览相关科普文章</p>
            </div>

            <div className="flex items-center gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
              <Link
                to="/category/shengli-yuanli"
                onClick={() => setActiveCategory('shengli-yuanli')}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeCategory === 'shengli-yuanli'
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                生理原理
              </Link>
              <Link
                to="/category/jiqiao-fangfa"
                onClick={() => setActiveCategory('jiqiao-fangfa')}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeCategory === 'jiqiao-fangfa'
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                技巧方法
              </Link>
              <Link
                to="/category/jiankang-zhishi"
                onClick={() => setActiveCategory('jiankang-zhishi')}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeCategory === 'jiankang-zhishi'
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                健康知识
              </Link>
              <Link
                to="/category/changjian-wuqu"
                onClick={() => setActiveCategory('changjian-wuqu')}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeCategory === 'changjian-wuqu'
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                常见误区
              </Link>
              <Link
                to="/category/all"
                onClick={() => setActiveCategory('all')}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeCategory === 'all'
                    ? 'bg-secondary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                全部文章
              </Link>
            </div>

            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-background-100 text-foreground-300">
                  <i className="ri-article-line text-2xl"></i>
                </div>
                <p className="mt-4 text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}